import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.scss';
import AppWithProvider from './app';

ReactDOM.render(
  <React.StrictMode>
    <AppWithProvider />
  </React.StrictMode>,
  document.getElementById('root'),
);
